import { useState, useCallback } from 'react';
import { obrasSocialesAPI } from '../../../core/api/api';

export const useRequisitos = () => {
  const [requisitos, setRequisitos] = useState([]);
  const [loading, setLoading] = useState(false);

  const cargar = useCallback(async () => {
    setLoading(true);
    try {
      const res = await obrasSocialesAPI.getRequisitos();
      setRequisitos(res.data || []);
    } finally {
      setLoading(false);
    }
  }, []);

  const guardar = useCallback(async (requisito) => {
    setLoading(true);
    try {
      await obrasSocialesAPI.guardarRequisito(requisito);
    } finally {
      setLoading(false);
    }
  }, []);

  const actualizar = useCallback(async (id, requisito) => {
    setLoading(true);
    try {
      await obrasSocialesAPI.actualizarRequisitoCatalogo(id, requisito);
    } finally {
      setLoading(false);
    }
  }, []);

  const eliminar = useCallback(async (id) => {
    setLoading(true);
    try {
      await obrasSocialesAPI.eliminarRequisitoCatalogo(id);
    } finally {
      setLoading(false);
    }
  }, []);

  return { requisitos, loading, cargar, guardar, actualizar, eliminar };
};
